import moment from 'moment';
import Avatar from '@components/avatar';
import { Link } from 'react-router-dom';
import { Eye } from 'react-feather';
import { UncontrolledTooltip } from 'reactstrap';

const renderClient = (row) => {
  return (
    <Avatar
      initials
      className="me-1"
      color={'light-primary'}
      content={row.user.fullName || ''}
    />
  );
};


export const columns = ({ toggleSidebar }) => [
  {
    name: 'Usuario',
    sortable: true,
    minWidth: '270px',
    sortField: 'fullName',
    selector: (row) => row.user.fullName,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        {renderClient(row)}
        <div className="d-flex flex-column">
          <Link
            to={`/users/view/${row.user._id}`}
            className="user_name text-truncate text-body"
          >
            <span className="fw-bolder">
              {row?.user.fullName || 'No completado'}
            </span>
          </Link>
          <small className="text-truncate text-muted mb-0">
            {row.user.email}
          </small>
        </div>
      </div>
    )
  },
  {
    name: 'FECHA',
    sortable: false,
    minWidth: '180px',
    sortField: 'name',
    selector: (row) => row.createdAt,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder">
            {moment(row.createdAt).format('DD/MM/YYYY')}
          </span>
        </div>
      </div>
    )
  },
  {
    name: 'COMENTARIO',
    minWidth: '120px',
    center: true,
    selector: (row) => row.feedback,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.feedback.substring(0, 50)}...
      </span>
    )
  },
  {
    name: 'ACCIONES',
    minWidth: '100px',
    center: true,
    cell: (row) => (
      <div className="column-action">
        <Eye
          size={17}
          id={`view-${row._id}`}
          className="cursor-pointer"
          onClick={() => toggleSidebar(row)}
        />
        <UncontrolledTooltip placement="top" target={`view-${row._id}`}>
          Ver Detalle
        </UncontrolledTooltip>
      </div>
    )
  }
];
